import './footer.css';
export const Footer = () => {
    return (
        <div id='footer'>
            <div className='container text-center'>
                <div className='footer-menu'>
                    <img className="main-footer-logo" src="img/logo.svg" alt="Logo"/>
                    <div style={{textAlign: "left"}}>
                        <h3>Ruby Rock</h3>
                        <ul>
                            <li>
                                <a href='/#asset' className='page-scroll'>
                                    About
                                </a>
                            </li>
                            <li>
                                <a href='/mint' className='page-scroll'>
                                    Mint Now
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div style={{textAlign: "left"}}>
                        <h3>References</h3>
                        <ul>
                            <li>
                                <a href='/legal' className='page-scroll'>
                                    Legal
                                </a>
                            </li>
                            <li>
                                <a href='/RubyRock_Litepaper_v1.pdf' target="_blank">
                                    LitePaper
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div style={{textAlign: "left"}}>
                        <h3>
                            Extra
                        </h3>
                        <ul>
                            <li>
                                <a href='/technology' className='page-scroll'>
                                Technology & Security
                                </a>
                            </li>
                            <li>
                                <a href='/ngo' className='page-scroll'>
                                    NGO
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='copyright'>
                    <p style={{textAlign: "left"}}>
                        <small>Copyright &copy; 2022. All rights reserved.</small>
                    </p>
                    <div>
                        <img src="img/specimen_labs_logo.svg" className='specimen-labs-logo' alt="Specimen Labs" style={{paddingLeft:"10px"}}/>
                    </div>
                    <p style={{textAlign: "right"}}>
                        <small>Web by <a href="https://maw.dev/" title="Web by Maw" rel="noreferrer" target="_blank">Maw</a></small>
                    </p>
                </div>
            </div>
        </div>
  )
}